import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  title: `Want double the Segment credits?`,
}

const descriptionLink = {
  text: `Check out our FAQ`,
  url: `https://segment.com/docs/guides/usage-and-billing/startup-program/`,
}

const description = (
  <>
    Send this page to your investor or accelerator where they can apply to be a partner. Have more questions?{` `}
    <a href={descriptionLink.url}>{descriptionLink.text}</a>.
  </>
)

const WantDoubleSegmentCredits: FC<PropsWithChildren<unknown>> = () => (
  <Wrapper>
    <StyledSection variant="centered">
      <Section.Copy>
        <StyledCopyTextBase centered={true}>
          <CopyText.Heading variant="h4" tag="h2">
            {copy.title}
          </CopyText.Heading>
          <CopyText.Description variant="pMedium">{description}</CopyText.Description>
        </StyledCopyTextBase>
      </Section.Copy>
    </StyledSection>
  </Wrapper>
)

const Wrapper = styled.div``

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 40px;
    row-gap: 24px;
  }
`

const StyledCopyTextBase = styled(CopyTextBase)`
  max-width: 684px;
`

export default WantDoubleSegmentCredits
